<template>
  <div class="slideVertical" >
    <div class="slideWrap">
      <div
        class="slideContainer"
      >
        <div
          class="slideItem"
          v-for="item, index  in gallery"
          :key="item.ID"
          :class="index == swiperIndex.activeIndex? 'imageActive main_button_boder' : ''"

          @click="selectImg(item.ID)"
        >
          <i
            v-if="item.media_content_type === 'video' || item.media_content_type === 'external_video'"
            class="slideItem__video-icon"
            :class="{
              'el-icon-video-play': item.media_content_type === 'video',
              'iconfont icon-cm-youtube': item.media_content_type === 'external_video',
            }"
          ></i>
          <v-img-card :data_src="item.thumbnail" :data_url="item.url" alt="" card_type="auto"></v-img-card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import vImgCard from '@/js/components/common/imgCard.vue';

export default {
  props: {
    gallery: {
      type: Array,
      require: true,
    },
    offsetBottom: {
      type: Number,
      default: 10,
    },
    slidesView: {
      type: Number,
      default: 5,
    },
    slideHeight: {
      type: Number,
      default: 500,
    },
    swiperIndex: {
      type: Object,
    },
  },
  data() {
    return {
      count: 0,
    }
  },
  methods: {
    selectImg(ID) {
      this.$store.dispatch('change_feature_image_id', ID)
    },
  },
  computed: {
    itemHeight() {
      let height = 0
      // 如果图片数量大于设置的一页可见数量,那么高度要减去上下按钮的40px
      height = this.gallery.length > this.slidesView ? this.slideHeight - 45 : this.slideHeight
      height = height / this.slidesView - this.offsetBottom
      return height
    },
  },
  watch: {
    '$store.state.feature_image_id'() {
      this.gallery.some((item, index) => {
        if (item.ID == this.$store.state.feature_image_id) {
          if (index - this.slidesView < 0) {
            this.count = 0
            console.log(this.count, 0)
          } else if (index + this.slidesView > this.gallery.length) {
            this.count = this.gallery.length - this.slidesView
            console.log(this.count, 1)
          } else {
            this.count = index
          }
        }
      })
    },
  },
  components: {
    vImgCard,
  },
}
</script>
<style scoped lang='scss'>
.slideVertical {
  min-height: 500px;
  position: relative;
  overflow: hidden;
  button {
    width: 100%;
    height: 25px;
    position: absolute;
    left: 0;
    background-color: #f2f2f2;
    z-index: 3;
  }
  .prev {
    top: 0;
  }
  .next {
    bottom: 0;
  }
  .slideWrap {
    height: 100%;
    // overflow: hidden;
    overflow-y: scroll;
    &::-webkit-scrollbar { width: 0 !important }
    .slideContainer {
      transition: all 0.5s;
      .slideItem {
        //border: 1px solid #f2f2f2;
        position: relative;
        margin-bottom: 20px;
        cursor: pointer;
        &__video-icon {
          position: absolute;
          z-index: 2;
          font-size: 30px;
          color: #fff;
          height: 100%;
          width: 100%;
          background: #00000035;
          top: 0;
          left: 0;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        img {
          max-height: 100%;
          width: 100%;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
        }
      }
      .slideItem:last-child{
        margin-bottom: 0 !important;
      }
      .imageActive {
        .imgCard{
          border: 1px solid var(--main-btn-bg) !important;
        }
      }
    }
  }
}
</style>
